'use client'

import React from 'react'
import Event from '@/utils/event'
import SafeLocalStorage from '@/utils/safe-local-storage'

import { STORAGE_ACK_WALLET_WARNING } from '@/utils/constants'

const OVERWRITE = true

const useWalletWarning = () => {
	React.useMemo(() => {
		if (typeof window === 'undefined') {
			return
		}

		// is PWA
    const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator?.standalone)
		if (!SafeLocalStorage.getItem(STORAGE_ACK_WALLET_WARNING) && (!isInStandaloneMode)) {
			Event.emit('open-wallet-warning-modal')
		}
	}, [])
}

const ackWalletWarning = () =>
	SafeLocalStorage.setItem(STORAGE_ACK_WALLET_WARNING, new Date().toISOString(), OVERWRITE)

export { useWalletWarning as default, ackWalletWarning }
